import axios from "axios";

const CLOUDINARY_CLOUD_NAME =
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "afrilocales";
const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "svmprhvf";
const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/upload`;

export const uploadImage = async (imgFile) => {
  const photoData = new FormData();
  photoData.append("file", imgFile);
  photoData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
  return await axios
    .post(CLOUDINARY_UPLOAD_URL, photoData)
    .then((response) => {
      return response?.data?.secure_url;
    })
    .catch(() => {
      return "https://www.gravatar.com/avatar/a208380389f40731d3ac10839ec143a2?d=identicon&r=pg&s=100";
    });
};

export default uploadImage;
